const blackboardListMessages = {
  'blackboardList.title': '{deviceName} 黒板一覧',
  'blackboardList.add': '新規登録',
  'blackboardList.item.title': '工事名',
  'blackboardList.item.subtitle': '工種',
  'blackboardList.item.operatorName': '操作者',
  'blackboardList.item.createdAt': '登録日時',
  'blackboardList.item.action': '操作',
  'blackboardList.item.action.detail': '詳細',
  'blackboardList.item.action.remoteSupport': '遠隔支援',
  'blackboardList.item.action.remoteSupportEnd': '遠隔終了',
  'blackboardList.registration.title.create': '新規登録',
  'blackboardList.registration.title.update': '黒板詳細',
  'blackboardList.registration.item.title': '工事名',
  'blackboardList.registration.item.titleSuffix': '接尾語',
  'blackboardList.registration.item.subtitle': '工種',
  'blackboardList.registration.item.note': '備考',
  'blackboardList.registration.item.createdAt': '登録日時',
  'blackboardList.registration.item.operatorName': '操作者',
};

export default blackboardListMessages;
